// extracted by mini-css-extract-plugin
export var drawerContent = "_2s-0";
export var valueBlock = "_2s-1";
export var valueBlockFrom = "_2s-2 _2s-1";
export var valueBlockTo = "_2s-3 _2s-1";